const accordion = () => {
	const accordions = [...document.querySelectorAll(".js-accordion")]
	accordions.forEach((el) => {
		const trigger = el.querySelector(".js-accordion-trigger")
		trigger.addEventListener("click", () => {
			el.classList.toggle("is-collapsed")
		})
	})
}
window.onload = accordion